<template>
  <div>
    <v-overlay
      :model-value="isLoading"
      location="center"
      scrim="white"
      :opacity="opacity"
      z-index="100"
    >
      <div class="l_elmloading">
        <div class="elmloading">
          <div class="elmloading_icon"></div>
        </div>
      </div>
    </v-overlay>
  </div>
</template>
<script lang="ts" src="./FullScreenLoading.ts" />
<style lang="scss" scoped></style>
